var successClass = 'Success';
export default function checkIfResponseSuccess(response) {
    return response.ResponseClass == successClass;
}
//# sourceMappingURL=checkIfResponseSuccess.js.map